/**
 * CrossBranchStockPage — standalone page wrapper for CrossBranchStockView.
 * Mounted at /ha/all-branch-stock via HAModule. Also embedded (with
 * `embedded=true`) inside Product Catalogue and Stock Transfers tabs.
 */
import React from 'react';
import CrossBranchStockView from './CrossBranchStockView';

export default function CrossBranchStockPage() {
  return <CrossBranchStockView testidPrefix="cbs-page" />;
}
